export const modalTypes = {
  DEFAULT: -1,
  CREATE_USER_ONBOARD_STATUS: 0,
  LINK_TO_MIT_ID_STATUS: 1,
};
